import { css } from '@/styled-system/css';

export const modalCloseButtonStyles = css.raw({
  insetBlockStart: 'tighter',
  insetInlineEnd: 'tighter',
  position: 'absolute',
  zIndex: 100,
});
